import type { CustomerListItem } from '@/api/customers';
import { fullName } from '@/lib/validation';

interface ResultRowProps {
  customer: CustomerListItem;
  onOpen: (id: string) => void;
}

const eur = new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });

export function ResultRow({ customer, onOpen }: ResultRowProps) {
  const meta = [customer.email, customer.phone].filter(Boolean).join(' · ');
  const hasActivity = (customer.txns_12m ?? 0) > 0 || (customer.spend_total ?? 0) > 0;
  return (
    <button type="button" className="result-row" onClick={() => onOpen(customer.customer_id)}>
      <span>
        <span className="result-row-name">
          {fullName(customer.first_name, customer.last_name)}
          {customer.is_wholesale && <span className="row-badge row-badge--wholesale">Wholesale</span>}
          {customer.has_web && <span className="row-badge row-badge--web">Web</span>}
        </span>
        {meta && <span className="result-row-meta" style={{ display: 'block' }}>{meta}</span>}
      </span>
      <span className="result-row-right">
        {hasActivity && (
          <span className="result-row-activity">
            {(customer.txns_12m ?? 0) > 0
              ? `${customer.txns_12m} txn${customer.txns_12m === 1 ? '' : 's'} · ${eur.format(customer.spend_12m ?? 0)} (12 mo)`
              : `${eur.format(customer.spend_total ?? 0)} lifetime`}
            {customer.last_visit && (
              <span className="result-row-lastvisit">last {new Date(customer.last_visit).toLocaleDateString('en-IE', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
            )}
          </span>
        )}
        <span className="result-row-store">{customer.store_code}</span>
      </span>
    </button>
  );
}
